import { Injectable, InjectionToken } from '@angular/core';
import { EnvService } from './env.service';

export const BuildProps = new InjectionToken('BuildProps');

@Injectable({
  providedIn: 'root',
})
export class AppEnvironmentService {
  endpointFlag: string;
  appliesTo: string[];
  appliesRegExp: RegExp;

  constructor(public buildProps: EnvService) {
    if (buildProps.endpointFlag) {
      this.initEndpointFlag(buildProps.endpointFlag);
    }
  }
  initEndpointFlag(endpointFlag: string) {
    const parts = endpointFlag.split(':');

    this.endpointFlag = parts[0];

    if (parts[1]) {
      this.appliesTo = parts[1].split(',');

      this.appliesRegExp = new RegExp(`${this.appliesTo.join('|')}`);
      return;
    }
  }

  applyEndpointFlag(urlString: string) {
    if (!this.endpointFlag) {
      return urlString;
    }

    const apply = urlString.match(this.appliesRegExp);

    if (!apply) {
      return urlString;
    }

    return urlString.replace('slt/api', `slt/${this.endpointFlag}/api`);
  }
}
